import { PushNotificationsCardFragment_notificationSubscriptions$key } from './__generated__/PushNotificationsCardFragment_notificationSubscriptions.graphql';
import Button from 'components/atoms/Button/Button';
import Card from 'components/atoms/Card/Card';
import Txt from 'components/atoms/Txt/Txt';
import classes from './PushNotificationsCard.module.scss';
import React from 'react';
import { graphql, useFragment } from 'react-relay';
import { useEnablePushNotifications } from 'hooks/useEnablePushNotifications';
import { usePushNotificationVisibility } from './usePushNotificationsVisibility';
import { PUSH_NOTIFICATION_VISIBILITY_STORAGE_KEY } from 'components/templates/AuthenticationProvider/Types';
import clsx from 'clsx';

export type NotificationCardProps = {
  userName?: string | null;
  pushNotificationsRef: PushNotificationsCardFragment_notificationSubscriptions$key;
};

const fragmentSpec = graphql`
  fragment PushNotificationsCardFragment_notificationSubscriptions on NotificationSubscriptions {
    surveyInviteContactChannels
  }
`;

export default function PushNotificationsCard({ pushNotificationsRef }: NotificationCardProps) {
  const enablePushNotifications = useEnablePushNotifications();
  const subscriptions = useFragment(fragmentSpec, pushNotificationsRef);

  const { visibility, hideForDays } = usePushNotificationVisibility();

  const handleConfirm = async () => {
    await enablePushNotifications();
  };

  const handleOnCancel = () => {
    hideForDays(7);
  };

  React.useEffect(() => {
    if (Date.now() > visibility.expDate) {
      window.localStorage.removeItem(PUSH_NOTIFICATION_VISIBILITY_STORAGE_KEY);
    }
  }, [visibility.expDate]);

  // Only display card if:
  // 1. Browser push notifications undefined, or...
  // 2. Account push notifications disabled, or...
  // 3. User hasn't closed this component within the past week
  if (
    visibility.isVisible &&
    typeof Notification !== 'undefined' &&
    ((Notification.permission !== 'granted' && Notification.permission !== 'denied') ||
      !subscriptions.surveyInviteContactChannels?.includes('pushNotification'))
  ) {
    return (
      <Card className={classes.cardRoot}>
        <Txt className={classes.notificationText}>
          Get notified when there are new surveys available, so you never miss a chance to earn
        </Txt>

        <>
          <Button
            className={classes.actionButtons}
            buttonType="primary"
            buttonSize="large"
            onClick={handleConfirm}
          >
            <Txt>Please notify me</Txt>
          </Button>

          <Button
            className={clsx(classes.actionButtons, classes.cancelButton)}
            buttonType="tertiary"
            buttonSize="large"
            onClick={handleOnCancel}
          >
            <Txt>Not this time</Txt>
          </Button>
        </>
      </Card>
    );
  }
}
